import { Divider } from 'antd'

import { PageBreadcrumbs } from 'src/components'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'

import { ReportDetailsFilters } from '../components/ReportDetailsFilters'
import { ReportDetailsTable } from '../components/ReportDetailsTable'
import { detailsTableData } from '../data'

export const ReportDetailsPage = () => {
  const { t } = useLocales()

  return (
    <PageBreadcrumbs
      title={t('reports.clinical_administrative_activity_report')}
      items={[
        {
          title: t('menu.reports'),
          path: paths.reports.root
        },
        {
          title: t('reports.clinical_administrative_activity_report')
        }
      ]}
    >
      <ReportDetailsFilters />

      <Divider />

      <ReportDetailsTable dataSource={detailsTableData} />
    </PageBreadcrumbs>
  )
}
